import { render } from "./BasicInfoPage.vue?vue&type=template&id=ce8e4a2e&scoped=true"
import script from "./BasicInfoPage.vue?vue&type=script&lang=js"
export * from "./BasicInfoPage.vue?vue&type=script&lang=js"

import "./BasicInfoPage.vue?vue&type=style&index=0&id=ce8e4a2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8e4a2e"]])

export default __exports__